<cb-dialog [dialogHeading]="getTitle()">
    <div class="flex-col flex">
        @if (mappedItem?.exteriorImageUrl || mappedItem?.floorPlanImageUrl) {
            <mat-tab-group class="flex" mat-stretch-tabs="false">
                @if (mappedItem?.exteriorImageUrl) {
                    <mat-tab label="Render">
                        <div class="mat-padding image-tab flex-row center-center">
                            <cb-image-button
                                class="flex-row main-img"
                                [fullImage]="true"
                                [baseUrl]="mappedItem?.exteriorImageUrl"
                            >
                            </cb-image-button>
                        </div>
                    </mat-tab>
                }
                @if (mappedItem?.floorPlanImageUrl) {
                    <mat-tab label="Floor Plan">
                        <div class="mat-padding image-tab flex-row center-center">
                            <cb-image-button
                                class="flex-row main-img"
                                [fullImage]="true"
                                [baseUrl]="mappedItem?.floorPlanImageUrl"
                            >
                            </cb-image-button>
                        </div>
                    </mat-tab>
                }
                @if (mappedItem?.exteriorImageUrl && mappedItem?.floorPlanImageUrl) {
                    <mat-tab label="Split View">
                        <div class="mat-padding image-tab flex-row center-center">
                            <div class="flex-col flex">
                                <cb-image-button
                                    [fullImage]="true"
                                    class="flex-row split-img"
                                    [baseUrl]="mappedItem?.exteriorImageUrl"
                                >
                                </cb-image-button>
                            </div>
                            <div class="flex-col flex">
                                <cb-image-button
                                    [fullImage]="true"
                                    class="flex-row split-img"
                                    [baseUrl]="mappedItem?.floorPlanImageUrl"
                                >
                                </cb-image-button>
                            </div>
                        </div>
                    </mat-tab>
                }
            </mat-tab-group>
        }
        <mat-tab-group mat-stretch-tabs="false">
            <mat-tab label="Details">
                <cb-view-house-land-details [mappedItem]="mappedItem"></cb-view-house-land-details>
            </mat-tab>
            <mat-tab label="Specification" [disabled]="!mappedItem?.currentDesignScheme">
                <ng-template matTabContent>
                    @if (lotSpecVersionMappedItem) {
                        <cb-view-house-land-specification
                            class="flex"
                            [mappedItem]="lotSpecVersionMappedItem"
                        >
                        </cb-view-house-land-specification>
                    }
                    @if (!lotSpecVersionMappedItem) {
                        <cb-loading-spinner class="cb-margin flex" style="height: 300px">
                        </cb-loading-spinner>
                    }
                </ng-template>
            </mat-tab>
            @if (documents && documents.length > 0) {
                <mat-tab label="Documents">
                    <div *cbWaitFor="mappedItem">
                        <cb-document
                            [entity]="mappedItem"
                            [permissions]="documentPermissions"
                            [includeLinked]="true"
                            [hideUploadButton]="true"
                            [systemArea]="systemArea"
                        >
                        </cb-document>
                    </div>
                </mat-tab>
            }
        </mat-tab-group>
    </div>
    <div class="flex-col flex" actions>
        <div position="relative">
            <mat-divider></mat-divider>
        </div>
        <div class="footer-buttons flex-row flex">
            <button
                mat-stroked-button
                color="accent"
                (cbClick)="viewLotInterests($event)"
                [disabled]="!lotInterestsEnabled()"
            >
                Lot Interests
            </button>
            <span class="flex"></span>
            @if (lotInterestCanAdd()) {
                <button mat-stroked-button color="accent" (cbClick)="addToLead()">
                    Add to Existing Lead
                </button>
            }
            @if (canCreate()) {
                <button mat-stroked-button color="accent" (cbClick)="createLead()">
                    Create Lead
                </button>
            }
            @if (canCreateSale()) {
                <button mat-stroked-button color="accent" (cbClick)="createSale()">
                    Create Client Sale
                </button>
            }
            <button mat-stroked-button (click)="cancel()">Close</button>
        </div>
    </div>
</cb-dialog>
